export function getCrystalsImagePath(id) {
  return `/img/crystals/${id}.jpg`;
}
